/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../devicesettings/profiles/v2/model/shared/device_profile';
import '../../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "posmodes": {
        "nested": {
          "modes": {
            "nested": {
              "model": {
                "nested": {
                  "Mode": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "applicationProfile": {
                        "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                        "id": 3,
                        "rule": "optional"
                      },
                      "metadata": {
                        "type": ".squareup.posmodes.modes.model.ModeMetadata",
                        "id": 4,
                        "rule": "optional"
                      },
                      "version": {
                        "type": "uint64",
                        "id": 5,
                        "rule": "optional"
                      },
                      "engine": {
                        "type": ".squareup.posmodes.modes.model.Mode.Engine",
                        "id": 6,
                        "rule": "optional"
                      },
                      "linkedDeviceCount": {
                        "type": "int32",
                        "id": 7,
                        "rule": "optional",
                        "options": {
                          "default": 0
                        }
                      },
                      "createdAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 8,
                        "rule": "optional"
                      },
                      "isLocal": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Engine": {
                        "values": {
                          "ENGINE_DO_NOT_USE": 0,
                          "APPOINTMENTS": 1,
                          "INVOICES": 2,
                          "RETAIL": 3,
                          "RESTAURANT": 4,
                          "SQUARE": 5,
                          "KIOSK": 6
                        }
                      }
                    }
                  },
                  "ModeMetadata": {
                    "fields": {
                      "templateNameId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "templateName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "templateIconUrl": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "templateImageUrl": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "requiredFeatureName": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.posmodes?.nested?.modes?.nested?.model?.nested?.Mode && !$root.nested?.squareup?.nested?.posmodes?.nested?.modes?.nested?.model?.nested?.Mode?.nested?.Engine && !$root.nested?.squareup?.nested?.posmodes?.nested?.modes?.nested?.model?.nested?.ModeMetadata) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Mode @ squareup/posmodes/modes/model/mode.proto at 13:1
 */
export const Mode = $root.lookupType('squareup.posmodes.modes.model.Mode');
fixType(Mode, {
  id: {
    required: true
  },
  name: {
    required: true
  },
  metadata: {
    required: true
  },
  version: {
    required: true
  },
  engine: {
    required: true
  }
});
Builder.createAndAttachToType(Mode);
/**
 * Engine (vertical) the mode should be run on
 *
 * SOURCE Engine @ squareup/posmodes/modes/model/mode.proto at 30:3
 */
Mode.Engine = $root.lookupEnum('squareup.posmodes.modes.model.Mode.Engine').values;
/**
 * SOURCE ModeMetadata @ squareup/posmodes/modes/model/mode.proto at 50:1
 */
export const ModeMetadata = $root.lookupType('squareup.posmodes.modes.model.ModeMetadata');
fixType(ModeMetadata);
Builder.createAndAttachToType(ModeMetadata);